export enum MailboxSearchScope {
  My = 'my',
  Sent = 'sent',
  Scheduled = 'scheduled',
  Candidates = 'candidates',
  FollowedCandidates = 'followed_candidates',
  FollowedJobs = 'followed_jobs',
  NotDelivered = 'not_delivered',
  NotConverted = 'not_converted',
  Archive = 'archive',
  General = 'general',
  Jobs = 'jobs',
}

export enum MailboxDeliveryStatus {
  Scheduled = 'scheduled',
  Sent = 'sent',
}

export enum MailboxMessageDeliveryStatus {
  Scheduled = 'scheduled',
  Delivered = 'delivered',
}
